import React from "react";
import Background from "../images/karelys-ruiz.jpg";

export default function Hero() {
  return (
    <div className="h-screen w-screen relative">
      <img src={Background} className="object-cover h-screen w-screen" alt="Acne treatment" />
    </div>
  );
}